import React, { useState, useEffect, useContext } from "react";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-number-input/style.css';
import { BrowserView, isMobile, MobileView } from "react-device-detect";
import {ButtonLoader} from "../../utils/Loaders/ButtonLoader";
import {useFetch} from "../../api/FetchApiData";
import { useWindowWidth } from "@react-hook/window-size";
import { AddressMap } from "../../map/users/AddressMap";
import remove_icon from '../../icons/remove.webp';
import deliv_icon from '../icons/delivery.webp';
import DeviceRegistration from "../device/Device";
import ShowImage from "../../utils/media/ShowImage";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../AppContextProvider";

if (isMobile)
    import('./userinfo_mob.css').then(() => {});
else
    import('./userinfos.css').then(() => {});

export function Address({location, RemoveLocation})
{
    const [_location,setLocation] = useState(location);
    const [btnDisplay,setBtnDisplay] = useState({text:'+',display:'none'});
    const [_images,setImages] = useState([]);
    const fetchData = useFetch();

    useEffect(()=>{
        setImages(location.images);
        console.log(location);
    },[location])

    const DisplayDetails = ()=>
    {
        if(btnDisplay.display==='none')
            setBtnDisplay({text:'-',display:'block'});
        else
            setBtnDisplay({text:'+',display:'none'});
    }

    const OnFileImagesSet = (files)=>{
        //setImages(files);
    }

    const SaveAddress = ()=>{
        var formdata = new FormData();
        formdata.append('address',JSON.stringify(_location));
        _images.forEach
        ((img)=>{
            if(img instanceof Blob)
                formdata.append('images',img,img.name);
        });
        fetchData.PutFormData(formdata,'address/').then((result)=>{
            
        })
    }

    return(
    <div className="LocationBlock" style={{backgroundColor:'white'}}>
        <div className="location-block-text" style={{display:'inline-block',verticalAlign:'middle',width:'100%'}}>
            <label style={{display:'block',width:'100%',textAlign:'left'}}>{_location.label}
                <MobileView style={{float:'right',verticalAlign:'middle'}}>
                    <img onClick={e=>{RemoveLocation(location)}} src={remove_icon} style={{height:'20px',marginRight:'10px'}} />
                </MobileView> 
                <BrowserView style={{float:'right',verticalAlign:'top'}}>
                    <input onClick={e=>{RemoveLocation(location)}} type="button" className="LocationBlockRemove" value={'x'} />    
                </BrowserView> 
            </label>
            <div style={{width:'100%',marginTop:'5px'}}>
                <input disabled={_location.country==='France'} onClick={e=>{DisplayDetails()}}  type="button" value={btnDisplay.text} style={{width:'25px',height:'25px',margin:'0px',border:'none',display:'inline-block',border:'1px solid gray',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px'}} />
                <input disabled style={{display:'inline-block',overflowWrap: 'anywhere',paddingLeft:'5px',height:'20px',width:'70%',margin:'0px',fontSize:'xx-small'}} title={location.display_name} value={location.display_name} onChange={e=>{location.ville = e.target.value}} className="LocationCityInput" placeholder="Ville" type="text" />
            </div>
            <div style={{margin:'auto',marginTop:'5px',textAlign:'left',width:'90%',display:btnDisplay.display}}>
                <label style={{fontWeight:'normal',fontSize:'x-small'}}>Ville : </label>
                <input disabled style={{width:'90%',marginBottom:'5px',fontSize:'xx-small'}} value={location.ville} onChange={e=>{location.ville = e.target.value}} className="LocationCityInput" placeholder="Ville" type="text" />
                <label style={{fontWeight:'normal',fontSize:'x-small'}}>Quartier : </label>
                <input disabled style={{width:'90%',marginBottom:'5px',fontSize:'x-small'}} value={location.neighbourhood} onChange={e=>{location.neighbourhood = e.target.value}} className="LocationCityInput" placeholder="Quartier" type="text" />
                <label style={{fontWeight:'normal',fontSize:'x-small'}}>Commentaire : </label>
                <input disabled style={{width:'90%',marginBottom:'5px',fontSize:'xx-small'}} value={location.comment} onChange={e=>{location.comment = e.target.value}} className="LocationCityInput" placeholder="Commentaire" type="text" />
                <div style={{display:'flex',flexDirection:'row'}}>
                    {(!!_images) && _images.map((imag,index)=>{
                        return <ShowImage imgObject={imag} trigger_size={{width:'50px',height:'50px'}} on_remove={()=>{}} />
                    })}
                    <button style={{width:'20px',height:'50px',padding:'0px 3px 0px 20px',marginLeft:'5px'}}>
                        <input multiple onChange={e=>{setImages([...e.target.files]);}} id="address-images" hidden type='file'/>
                        <label htmlFor="address-images" style={{float:'inline-end',textAlign:'center',margin:'auto',fontWeight:'bolder',fontSize:'medium'}}>+</label>
                    </button>
                </div>
                {_location.id && <input onClick={e=>{SaveAddress();}} type="button" value={'Mettre à jour'} style={{fontSize:'xx-small',float:'inline-end',borderRadius:'5px',width:'fit-content',margin:'5px',backgroundColor:'lightgreen',border:'none',height:'25px'}} />}
            </div>
        </div>                          
    </div>)
}


export default function InfoPerso({User,setUser})
{
    const [_User,_setUser] = useState(User);
    const screenWidth = useWindowWidth();
    const [loading,setLoading] = useState(false);
    const [mainLocation, setMainLocation] = useState({is_main:true, label:"", country:'Comores', coords:{}, type:'user_point', is_public:false,})
    const fetchData = useFetch();
    const {t} = useTranslation();
    
    const [AppState,setAppState] = useContext(AppContext);
    const [lang,setLang] = useState(AppState.settings.lang);
    const [btnSubmit,setBtnSubmit] = useState({text:t('user-info.enregistrer'),loading:false,bg:'lightgreen'})

    useEffect(()=>{
        _setUser({...User});
        User.locations.forEach(loc => {
            if(!!loc.is_main && loc.is_main)
                setMainLocation(loc);
        });
    },[User])

    useEffect(()=>{
        setLang(AppState.settings.lang);
        console.log(AppState.settings);
    },[AppState.settings.lang])

    useEffect(()=>{
        for(let i=0;i<_User.locations.length;i++)
        {
            if(_User.locations[i].is_main)
            { _User.locations[i] = mainLocation;_setUser({..._User});}

        }
    })

    const RemoveLocation = (location)=>
    {
        _User.locations.pop(location);
        _setUser({..._User});
        setLoading(true);

    }

    const update_info=()=>{
        let _user_ = {
            first_name:_User.first_name,
            last_name:_User.last_name,
            email:_User.email,
            birth_day:_User.birth_day,
            locations:[],
            phone:_User.phone
        };
        for(let i=0;i<_User.locations.length;i++)
        {
            _user_.locations.push({..._User.locations[i],coords:JSON.stringify(_User.locations[i].coords)});
        }
        setBtnSubmit({...btnSubmit,loading:true});
        fetchData.PutData(_user_,'user/').then((result)=>{
            if(result.result)
            {
                setBtnSubmit({...btnSubmit,bg:'lightgreen',loading:false,text:'Enregistré avec succès'});
                setTimeout(()=>{setBtnSubmit({...btnSubmit,bg:'skyblue',loading:false,text:'Enregistrer'});},[5000]);
            }
            else
            {
                setBtnSubmit({...btnSubmit,loading:false,bg:'orangered',text:'Erreur, reessayer ulterieurement'});
                setTimeout(()=>{setBtnSubmit({...btnSubmit,bg:'skyblue',loading:false,text:'Enregistrer'});},[5000]);
            }
        })
        
        

    }

    const main_address_input=()=>
    {

        const changeMainLocation=(label)=>{
            const loc = _User.locations.find(e=>e.label===label)
            setMainLocation({...loc,is_main:true})
        }

        //if(mainLocation.country==='Comores')
            return(
                <select onChange={e=>{changeMainLocation(e.target.value)}} value={mainLocation.label} style={{verticalAlign:'middle',width:"100%",height:'35px',border:'1px solid lightgray',borderTopRightRadius:'5px',borderBottomRightRadius:'5px',textAlign:'center',marginBottom:'10px'}}>
                {
                    _User.locations.map((add,index)=>{
                        return(
                            <option key={index} value={add.label}>
                                {add.label + ' ('+add.ville+')'}
                            </option>
                        )
                    })
                }
                </select>)
        //else
        //{return <input value={mainLocation.label} onChange={e=>{setMainLocation({...mainLocation,label:e.target.value,coords:{}})}} style={{verticalAlign:'middle',width:"70%",height:'35px',border:'1px solid lightgray',borderRadius:'5px',textAlign:'center',marginBottom:'10px'}} type="text" placeholder="Votre Adresse" />}
    }

    const OnAddressAdded = (location)=>{
        if(_User.locations.length<=3)
        {
            _User.locations.push(location);
            _setUser({..._User});
            return true;
        }
        else
        {
            return false;
        }
    }

    let mapHeight = 'fit-content';
    if(!isMobile)
        mapHeight = '500px';

    return(
        <div id="User-Infos" style={{margin:'auto',paddingBottom:'40px'}}>
            <fieldset className="userinfo-fieldset">
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('authentication.nom')} </label>
                    <input className="User-input" onChange={(e)=>{_User.last_name=e.target.value;_setUser({..._User});}} type="text" placeholder="votre nom" value={_User.last_name} />
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('authentication.prenom')} : </label>
                    <input className="User-input" onChange={(e)=>{_User.first_name=e.target.value;setUser({..._User});}} type="text" placeholder="votre prenom" value={_User.first_name} />
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('user-info.naissance')}</label>
                    <input className="User-input" value={_User.birth_day} onChange={(e)=>{_User.birth_day=e.target.value;setUser({..._User});}} type="date"  />
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('authentication.email')} </label>
                    <input onChange={e=>{_User.email=e.target.value;setUser({..._User});}} className="User-input" type="email" placeholder="votre email" defaultValue={_User.email} />
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('authentication.telephone')} </label>
                    <div className="User-input">
                        <PhoneInput
                            inputStyle={{width:'100%',textAlign:'center'}}
                                               
                            countries={["KM","FR"]} 
                            onChange={(e)=>{_User.phone = e}} 
                            onCountryChange={(e)=>{}} 
                            name="phone" placeholder={t("authentication.telephone")} value={_User.phone} />
                    </div>
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('user-info.addresse')}</label>
                    <div style={{border:'none',marginBottom:'5px',marginTop:'5px'}} className="User-input">
                        {/*
                        <select value={mainLocation.country} onChange={e=>{setMainLocation({...mainLocation,country:e.target.value})}} style={{verticalAlign:'middle',width:"25%",height:'35px',border:'1px solid lightgray',borderTopLeftRadius:'5px',borderBottomLeftRadius:'5px',textAlign:'center',marginBottom:'10px'}}>
                            <option>Comores</option>
                            <option>France</option>
                        </select>*/
                        }
                        {main_address_input()}  
                    </div>
                </div>
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('user-info.addresses')}</label>
                    <fieldset style={{height:'fit-content',borderRadius:'10px'}} className="User-input">
                            <div style={{verticalAlign:'middle',width:'100%',borderRadius:'10px',border:'none',height:'fit-content'}} className="User-input">
                                <div style={{width:"100%"}}>
                                    {_User.locations.map((location,index)=>{
                                        return (<Address key={index} location={location} RemoveLocation={RemoveLocation}  />);
                                    })}
                                </div>
                                <div>             
                                    <AddressMap country="Comores" locations={_User.locations} onAddressAdded={OnAddressAdded} btn_text={t('user-info.ajouter-addresse-comores')}/>
                                    <AddressMap country="France" locations={_User.locations} onAddressAdded={OnAddressAdded} btn_text={t('user-info.ajouter-addresse-francaise')}/>
                                </div>
                            </div>
                    </fieldset>
                </div>
                {(_User.is_staff) &&
                <div className="User-Champs" style={{display:'inline-flex',flexDirection:lang==='ar'?'row-reverse':'row',justifyItems:'center',alignItems:'center'}}>
                    <label>{t('user-info.appareil')}</label>
                    <div style={{border:'none',marginBottom:'5px',marginTop:'5px'}} className="User-input">
                        <DeviceRegistration owned={false} partner={'staff'} partner_id={_User.id} device={_User.device} />
                    </div>
                </div>}
            <div id="BtnSaveInfoPerso" style={{marginTop:'30px'}}>
                <ButtonLoader style={{backGroundColor:btnSubmit.bg,fontSize:'medium'}} onSubmit={e=>{update_info()}} loading={btnSubmit.loading}  text={btnSubmit.text} />
            </div>
            </fieldset>
        </div>
        );
}